"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataService = void 0;
const async_1 = __importDefault(require("async"));
const getChunk_1 = __importDefault(require("./getChunk"));
const constants_1 = require("../../constants");
const putChunk_1 = __importDefault(require("./putChunk"));
class DataService {
    getData(key, totalBytes, chunkSize) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!totalBytes || !chunkSize) {
                const response = yield getChunk_1.default(key, 0);
                switch (response.kind) {
                    case "notFound":
                        return null;
                    case "success":
                        return response.data;
                }
            }
            const bytes = new Uint8Array(totalBytes);
            const chunks = this.getChunkIndexes(totalBytes, chunkSize);
            try {
                yield async_1.default.mapLimit(chunks, 10, (i, callback) => __awaiter(this, void 0, void 0, function* () {
                    const response = yield getChunk_1.default(key, i);
                    if (response.kind === "success") {
                        const offset = i * chunkSize;
                        bytes.set(response.data, offset);
                        callback(null);
                    }
                    else {
                        callback({
                            name: "getDataFailed",
                            message: response.kind,
                        });
                    }
                }));
            }
            catch (e) {
                console.log(e);
                return null;
            }
            return bytes;
        });
    }
    putData(key, data, unchunked) {
        return __awaiter(this, void 0, void 0, function* () {
            if (unchunked) {
                yield putChunk_1.default(key, 0, data);
                return true;
            }
            const size = data.byteLength;
            const chunks = [];
            for (let byteStart = 0; byteStart < size; byteStart += constants_1.CHUNK_SIZE_BYTES) {
                const byteEnd = Math.min(size, byteStart + constants_1.CHUNK_SIZE_BYTES);
                const slice = data.slice(byteStart, byteEnd);
                chunks.push(slice);
            }
            yield async_1.default.forEachOfLimit(chunks, 10, (c, i, callback) => __awaiter(this, void 0, void 0, function* () {
                const index = i;
                yield putChunk_1.default(key, index, c);
                callback(null);
            }));
            return true;
        });
    }
    getChunkIndexes(totalBytes, chunkSize) {
        const chunks = [];
        let index = 0;
        for (let bytes = 0; bytes < totalBytes; bytes += chunkSize) {
            chunks.push(index++);
        }
        return chunks;
    }
}
exports.DataService = DataService;
